import styled from 'styled-components';

import { colours } from 'utils/theme';

import Stat from '../Stat';

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  ${p => p.theme.breakpoint.tablet} {
    margin-left: 90px;
  }
  ${p => p.theme.breakpoint.mobile} {
    margin-left: 0px;
    flex-wrap: wrap;
    flex: 0;
  }
`;

const Stats = props => {
  const handleClick = tab => e => props.onStatClick(tab, e);

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Stat
          onClick={handleClick('funding')}
          label={`Funding\nAwards`}
          value={props.totalFundedProjects}
          color={colours.grants}
          total={props.researchersTotalFundedProjects}
        />
        <Stat
          onClick={handleClick('posters')}
          label={`Tradeshow\nSessions`}
          color={colours.posters}
          value={props.totalTradeshowSessions}
          total={props.researchersTotalTradeShowSessions}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <Stat
          onClick={handleClick('publications')}
          label={`Published\nArticles`}
          color={colours.publications}
          value={props.totalPublications}
          total={props.researchersTotalPublications}
        />
        <Stat
          onClick={handleClick('clinicalTrials')}
          label={`Clinical\nTrials`}
          color={colours.trials}
          value={props.totalClinicalTrials}
          total={props.researchersTotalClinicalTrials}
        />
      </div>
    </Container>
  );
};

export default Stats;
